import React, { useState, useEffect } from "react";
import PathIcon from "../../../../Assets/Images/Wizard/your-path.svg";
import Line1 from "../../../../Assets/Images/Wizard/line-1-left.svg";
import Line2 from "../../../../Assets/Images/Wizard/line-2-left.svg";
import Line3 from "../../../../Assets/Images/Wizard/line-3-left.svg";
import Line4 from "../../../../Assets/Images/Wizard/line-4-left.svg";
import SkillFinder from "../SkillFinder";
import Select from "../IconSelect";
import ImagePreloader from "../ImagePreloader";
import { Config } from "../../../../Config";
import axios from "axios";
import YoEslider from "../YoEslider";

const Step2 = (props) => {
  const [CountryChecked, setCountryChecked] = useState(false);
  const [SkillsEntered, setSkillsEntered] = useState(false);
  const [Countries, setCountries] = useState([{ name: "Germany", id: "DE" }]);
  const [PathItemIds] = useState(["career", "income", "projects", "skills"]);
  const [SelectedPathIds, setSelectedPathIds] = useState([]);
  const [IncomeIds] = useState(["10k", "30k", "50k", "100k"]);
  const [SelectedSkills, setSelectedSkills] = useState([]);

  useEffect(() => {
    fetchCountries();
  }, []);

  const translateText = (LabelId) => {
    var Filter = "label_id";
    var Keyword = LabelId;
    var Label = props.LangData.filter((Obj) => {
      return Obj[Filter] === Keyword;
    });
    return Label[0].label_value;
  };

  const fetchCountries = () => {
    let Req = {
      method: "GET",
      baseURL:
        window._env_.API_URL +
        Config.AuthBaseURL +
        "/api/user-info/wizard/findAllCountries",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
      },
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        setCountries(Res.data);
      })
      .catch((Err) => {
        console.log(Err);
      });
  };
  const handleCountrySelectChange = () => {
    setCountryChecked(true);
  };

  const selectPathItem = (SelectedItem) => {
    let SelectedItems = [];
    if (
      !document.getElementById(SelectedItem).classList.contains("disabled-path")
    ) {
      document.getElementById("path-error-text").style.display = "none";

      if (
        !document.getElementById(SelectedItem).classList.contains("active-path")
      ) {
        document.getElementById(SelectedItem).classList.add("active-path");
      } else {
        document.getElementById(SelectedItem).classList.remove("active-path");
      }

      PathItemIds.map((Path) => {
        if (document.getElementById(Path).classList.contains("active-path")) {
          SelectedItems.push(Path);
        }
      });
      if (SelectedItems.length >= 2) {
        let NonSelectedPaths = [];
        PathItemIds.map((Path) => {
          if (
            !document.getElementById(Path).classList.contains("active-path")
          ) {
            NonSelectedPaths.push(Path);
          }
        });
        NonSelectedPaths.map((Path) => {
          document.getElementById(Path).classList.add("disabled-path");
        });
      } else {
        let NonSelectedPaths = [];
        PathItemIds.map((Path) => {
          if (
            !document.getElementById(Path).classList.contains("active-path")
          ) {
            NonSelectedPaths.push(Path);
          }
        });
        NonSelectedPaths.map((Path) => {
          document.getElementById(Path).classList.remove("disabled-path");
        });
      }
    } else {
      document.getElementById("path-error-text").style.display = "block";
      setTimeout(() => {
        document.getElementById("path-error-text").style.display = "none";
      }, 5000);
    }
    let ActivePaths = [];
    PathItemIds.map((Path) => {
      if (document.getElementById(Path).classList.contains("active-path")) {
        ActivePaths.push(Path);
      }
    });
    props.SavePathItems(ActivePaths);
  };

  const selectIncomeOption = (SelectedId) => {
    IncomeIds.map((Id) => {
      document.getElementById(Id).classList.remove("active-option");
    });
    document.getElementById(SelectedId).classList.add("active-option");
  };

  return (
    <div className="step-body">
      <ImagePreloader />
      <div className="your-path-title">
        <h1>{translateText("wizard_your_path")}</h1>
        <p>{translateText("wizard_ypur_path_info")}</p>
      </div>
      <div className="your-path">
        <img className="your-path-icon" alt="" src={PathIcon} />
        <section className="path-options">
          <span
            className="path-option"
            id="career"
            onClick={() => selectPathItem("career")}
          >
            <div alt="" className="stroke-1" src={Line1}></div>
            {translateText("wizard_next_career")}
          </span>
          <span
            className="path-option"
            id="income"
            onClick={() => selectPathItem("income")}
          >
            <div alt="" className="stroke-2" src={Line2}></div>
            {translateText("wizard_improve_income")}
          </span>
          <span
            className="path-option"
            id="projects"
            onClick={() => selectPathItem("projects")}
          >
            <div alt="" className="stroke-3" src={Line3}></div>
            {translateText("wizard_cool_projects")}
          </span>
          <span
            className="path-option"
            id="skills"
            onClick={() => selectPathItem("skills")}
          >
            <div alt="" className="stroke-4" src={Line4}></div>
            {translateText("wizard_improve_skills")}
          </span>
          <p className="error-message" id="path-error-text">
            {translateText("wizard_path_validation_text") + "."}
          </p>
        </section>
      </div>
      <section className="step-row">
        <p className="row-label">
          {translateText("wizard_select_country")} <p>*</p>
        </p>
        <Select
          Options={Countries}
          Label={translateText("preferred_country")}
          IconClassName="feather-flag"
          Id="preferred-country"
          ChangeEvent={() => handleCountrySelectChange()}
        />
      </section>
      <section className="step-row options-row">
        <p className="row-label">{translateText("years_of_experience")}</p>
        <YoEslider Default={1} />
      </section>
      <section className="step-row options-row">
        <p className="row-label skills-label">
          {translateText("wizard_select_top5_skills")} <p>*</p>
        </p>
        <SkillFinder
          AllSelected={() => setSkillsEntered(true)}
          NotAllSelected={() => setSkillsEntered(false)}
          PlaceHolder={translateText("search") + " ..."}
          SaveSkills={(Skills) => setSelectedSkills(Skills)}
          LangData={props.LangData}
        />
      </section>
      <div className="form-actions">
        <button className="previous" onClick={() => props.TriggerPrevStep()}>
          {translateText("previous")}
        </button>
        {CountryChecked && SkillsEntered && props.PathItems.length >= 1 ? (
          <button
            className="form-action-btn"
            onClick={() => props.TriggerNextStep(SelectedSkills)}
          >
            {translateText("next")}
          </button>
        ) : (
          <button className="form-action-btn disabled-btn">
            {translateText("next")}
          </button>
        )}
      </div>
    </div>
  );
};

export default Step2;
